import { useSite } from "./use-site";
import { useEnv } from "./use-env";
export var useContactEmail = function () {
  var site = useSite();
  var env = useEnv();
  return env.CONTACT_EMAIL || (site === null || site === void 0 ? void 0 : site.contactEmail) || '';
};